import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useUsers(
  params: Record<string, string | number | boolean | undefined> = {},
  options: { enabled?: boolean } = {},
) {
  const { enabled = true, ...rest } = { ...options };
  void rest;
  return useQuery({
    queryKey: ['users', params],
    queryFn: () => api.get<{ data: any[]; pagination: any }>('/users', params),
    enabled,
  });
}

export function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      email: string;
      name: string;
      password: string;
      role: string;
      locationId?: string | null;
      locationIds?: string[];
      extraPermissions?: string[];
      customRoleId?: string | null;
    }) => api.post('/users', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      ...data
    }: {
      id: string;
      name?: string;
      role?: string;
      isActive?: boolean;
      locationId?: string | null;
      locationIds?: string[];
      extraPermissions?: string[];
      customRoleId?: string | null;
    }) => api.put(`/users/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
